export enum OperationTypeEnum {
    Upstream = 'Upstream',
    Downstream = 'Downstream',
    Power = 'Power'
}


// WEBPACK FOOTER //
// ./src/app/shared/enum/global-enum.ts